import { css } from "@emotion/react";

export default function RequiredMark({ ...props }) {

    return < span
        css={css`opacity: 0.6;`}
        {...props}
    >
        *
    </ span>
}